import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../context-role-element';

export default {
  [CONTEXT.HOME]: {
    [ROLE.CONTAINER]: [
      ELEMENT.SECTION_BLOG,
      ELEMENT.SECTION_CONTACT_CARD,
      ELEMENT.SECTION_CONTACT_CARD_SKELETON,
      ELEMENT.SECTION_VIDEO_PARTNERS,
      ELEMENT.SECTION_DEFAULT_AND_CONTACT_CARD,
      ELEMENT.SECTION_REVIEW_CAROUSEL,
      ELEMENT.SECTION_FEATURE_CARD,
      ELEMENT.SECTION_FEATURE_CARD_SKELETON,
      ELEMENT.SECTION_INLINE_BANNER,
      ELEMENT.SECTION_INLINE_BANNER_SKELETON,
      ELEMENT.SECTION_BANNER_DEFAULT,
      ELEMENT.SECTION_BANNER_DEFAULT_SKELETON,
      ELEMENT.SECTION_VIDEO_BANNER,
      ELEMENT.SECTION_VIDEO_BANNER_SKELETON,
      ELEMENT.SECTION_GALLERY_CARD_CHIP,
      ELEMENT.SECTION_GALLERY_CARD_CHIP_SKELETON,
      ELEMENT.SECTION_CALCULATOR,
      ELEMENT.SECTION_CALCULATOR_SKELETON,
    ],
    [ROLE.CARD]: [ELEMENT.CARD, ELEMENT.DEFAULT_CARD, ELEMENT.CONTACT_CARD],
  },
} as TValidTestId;
